import type { TNAPIPathParams } from '~/types/napi-helpers'

// ForumPostFooter
function updatePostVote(
  userId: string,
  pathParams: TNAPIPathParams<
    '/napis/v1/discussion/post/{post_id_slug}/vote/{vote_value}/',
    'post'
  >,
  purpose: string = 'upvote' // default: upvote, options: upvote, downvote, remove_vote
) {
  console.log(`user ${purpose} post`, userId, pathParams.post_id_slug, pathParams.vote_value)
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/discussion/post/{post_id_slug}/vote/{vote_value}/',
    'post',
    pathParams
  )
}

// ForumCommentFooter
function updateCommentVote(
  userId: string,
  pathParams: TNAPIPathParams<
    '/napis/v1/discussion/comment-reply/{comment_reply_id_slug}/vote/{vote_value}/',
    'post'
  >,
  purpose: string = 'upvote' // default: upvote, options: upvote, downvote, remove_vote
) {
  console.log(
    `user ${purpose} comment`,
    userId,
    pathParams.comment_reply_id_slug,
    pathParams.vote_value
  )
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/discussion/comment-reply/{comment_reply_id_slug}/vote/{vote_value}/',
    'post',
    pathParams
  )
}

type useForumVoteReturnType = {
  updatePostVote: typeof updatePostVote
  updateCommentVote: typeof updateCommentVote
}

export function useForumVote(): useForumVoteReturnType {
  return {
    updatePostVote,
    updateCommentVote
  }
}
